module.exports = __webpack_public_path__ + "img/buy.52851ac7.svg";